import React from 'react';
import { Icon, IconName, IconSize } from '@televet/kibble-ui/build/components/Icon';
import { STRIPE_ERROR_CODE_MAP } from 'shared/components/SidePanel/components/InvoicingPanel/utils/constants';

export const getCardBrandIcon = (cardBrand: string, size?: IconSize): JSX.Element => {
  let iconName: IconName = 'creditCardLogoGeneric';
  switch (cardBrand.toLowerCase()) {
    case 'visa':
      iconName = 'creditCardLogoVisa';
      break;
    case 'mastercard':
      iconName = 'creditCardLogoMastercard';
      break;
    case 'american express':
    case 'amex':
      iconName = 'creditCardLogoAmex';
      break;
    case 'discover':
      iconName = 'creditCardLogoDiscover';
      break;
    case 'jcb':
      iconName = 'creditCardLogoJcb';
      break;
    case 'diners club':
      iconName = 'creditCardLogoDiners';
      break;
    case 'unionpay':
      iconName = 'creditCardLogoUnionpay';
      break;
    default:
      break;
  }

  return <Icon name={iconName} size={size || 'xl'} />;
};

export const getIsExpired = (month: number, year: number): boolean => {
  const expDate = new Date(year, month, 0, 23, 59, 59);
  return !(expDate > new Date());
};

export const getCardErrorMessage = (code = 'charge_declined'): string => {
  return STRIPE_ERROR_CODE_MAP[code as keyof typeof STRIPE_ERROR_CODE_MAP];
};
